<ng-container *ngIf="isSourceFound; else sourceFound">
  <video
    id="thk-video-player"
    #video
    height="100%"
    width="100%"
    class="video-js vjs-lock-showing vjs-fluid"
    controls
    playsinline="true"
    preload="auto"
    [autoplay]="autoplay"
  ></video>
</ng-container>
<!-- Class: vjs-fluid/h-full -->
<ng-template #sourceFound>
  <div class="absolute left-0 flex h-full w-full items-center justify-center bg-black">
    <svg-icon src="@assets/images/icons/video-camera.svg" class="w-14 text-slate-300"></svg-icon>
  </div>
</ng-template>
